module.exports = __webpack_public_path__ + "packs/media/images/junglepalestra-429f5b40916d1a3b89315d9a53f022c1.jpg";